import request from '@/utils/request'

let Ma_meetingApi = {

  /*会议列表*/
  list(data) {
    return request._post('/shop/plus.ma_meeting.Index/index', data);
},
/*添加会议*/
add(data) {
    return request._post('/shop/plus.ma_meeting.Index/add', data);
},
/*修改会议*/
edit(data) {
    return request._post('/shop/plus.ma_meeting.Index/edit', data);
},
/*删除会议*/
del(data) {
    return request._post('/shop/plus.ma_meeting.Index/del', data);
},
/*会议详情*/
detail(data) {
  return request._post('/shop/plus.ma_meeting.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_meeting.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_meeting.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_meeting.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_meeting.Index/export', data);
    },
}
export default Ma_meetingApi;



// WEBPACK FOOTER //
// ./src/api/ma_meeting.js